
<template>
  <div class="parentx">

    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe.left="onSwipeLeft">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <div class="header-sidebar flex items-end justify-between" slot="header">
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center w-full" to="/">
            <vs-row vs-justify="center">
              <img :src="logo" alt="logo" class="" v-if="logo" width="150px">
            </vs-row>
          </router-link>

        </div>
        <div class="shadow-bottom" v-show="showShadowBottom" />
        <VuePerfectScrollbar ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll">
          <template v-for="(item, index) in menuItemsUpdated">
            <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
              {{ item.header }}
            </span>
            <template  v-if="item.name == 'Manage Admins' && userType == 'superAdmin'">

              <!-- Nav-Item -->
  
                  <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="item.slug !== 'external' ? item.url : null"
                  :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon" :target="item.target"
                  :isDisabled="item.isDisabled"
                  :slug="item.slug">
                    <vs-row vs-type="flex" vs-justify="space-between">
                        <div class="badgeStyle">
                            <span v-show="!verticalNavMenuItemsMin" class="truncate">{{ item.name }}</span>
                        </div>
                        <div v-if="item.name == 'Messages'" class="badge font-semibold">
                          {{ totalMessages }}
                        </div>
                    </vs-row>
                    <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
                </v-nav-menu-item>
            

              <!-- Nav-Group -->
              <template v-else>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)" />
              </template>
              <!-- /Nav-Group v-if="item.name != 'Manage Admins'" -->
              
            </template>

            <template  v-if="item.name != 'Manage Admins'">
                  <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="item.slug !== 'external' ? item.url : null"
                  :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon" :target="item.target"
                  :isDisabled="item.isDisabled"
                  :slug="item.slug">
                    <vs-row vs-type="flex" vs-justify="space-between">
                        <div class="badgeStyle">
                            <span v-show="!verticalNavMenuItemsMin" class="truncate">{{ item.name }}</span>
                        </div>
                        <div v-if="item.name == 'Messages'" class="badge font-semibold">
                          {{ totalMessages }}
                        </div>
                    </vs-row>
                    <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
                </v-nav-menu-item>
              <template v-else>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)" />
              </template>
            </template>
          </template>
        </VuePerfectScrollbar>

      </div>
    </vs-sidebar>
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe.right="onSwipeAreaSwipeRight" />
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'
import EventBus from '@/event-bus'

import store from '@/store/store'

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems:     { type: Array,   required: true },
    title:            { type: String },
  },
  data: () => ({
    totalMessages: 0,
    userType: '',

    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false,
  }),
  computed: {
    isGroupActive() {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) { open = true }
              else if (item.submenu) { func(item) }
            })
          }
        }
        func(item)
        return open
      }
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice()

      for(let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex(ix => ix.header === item.header)
          for(let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem)
          }
        }
      }

      return clone
    },
    isVerticalNavMenuActive: {
      get()    { return this.$store.state.isVerticalNavMenuActive },
      set(val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType() { return this.$store.state.mainLayoutType },
    reduceButton: {
      get()    { return this.$store.state.reduceButton },
      set(val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced()   { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin() { return this.$store.state.verticalNavMenuItemsMin },
    windowWidth()     { return this.$store.state.windowWidth }
  },
  watch: {
    '$route'() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : "default"
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function() {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType()   { this.setVerticalNavMenuWidth() },
    reduceButton() { this.setVerticalNavMenuWidth() },
    windowWidth()  { this.setVerticalNavMenuWidth() }
  },
  methods: {
    setTotalMessages(params){
      this.totalMessages = params;
    },
    onSwipeLeft() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
    },
    onSwipeAreaSwipeRight() {
      if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
    },
    psSectionScroll() {
      this.showShadowBottom = this.$refs.verticalNavMenuPs.$el.scrollTop > 0 ? true : false
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {

      if(this.windowWidth > 1200) {
        if(this.layoutType === 'vertical') {
          this.reduce = this.reduceButton ? true : false
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
          const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
      if (this.reduceButton) this.reduce = false
      this.showCloseButton = true
      this.clickNotClose   = false
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
    },
    toggleReduce(val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
    
  },
  created(){
      EventBus.$on('totalMessages',this.setTotalMessages);
      let user = JSON.parse(this.$localStorage.get('user'));
      this.userType = user.user_type;
  },
}

</script>

<style>
    .badge {
      background-color: #4B4BF9;
      color: white;
      border-radius: 50%;
      min-width: 25px;
      width: auto;
      text-align: center;
      padding-top: 1%;
    }
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss"
</style>
